import '@styles/Popup/style.css'
import React, { FC, forwardRef } from 'react'
import { Popup } from 'reactjs-popup'

export declare type EventType = 'hover' | 'click' | 'focus' | 'right-click'
export declare type PopupPosition =
  | 'top left'
  | 'top center'
  | 'top right'
  | 'right top'
  | 'right center'
  | 'right bottom'
  | 'bottom left'
  | 'bottom center'
  | 'bottom right'
  | 'left top'
  | 'left center'
  | 'left bottom'
  | 'center center'

export interface IPopupProps {
  position?: PopupPosition
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element)
  open?: boolean
  disabled?: boolean
  nested?: boolean
  defaultOpen?: boolean
  children: React.ReactNode
  offsetX?: number
  offsetY?: number
  arrow?: boolean
  modal?: boolean
  lockScroll?: boolean
  closeOnDocumentClick?: boolean
  closeOnEscape?: boolean
  repositionOnResize?: boolean
  onOpen?: () => any
  onClose?: () => any
  contentStyle?: React.CSSProperties
  overlayStyle?: React.CSSProperties
  arrowStyle?: React.CSSProperties
  className?: string
  keepTooltipInside?: boolean | string
  on?: EventType | EventType[]
}

const PopupComponent = forwardRef<any, IPopupProps>(
  (
    {
      children,
      position,
      nested,
      trigger,
      open,
      disabled,
      defaultOpen,
      offsetX,
      offsetY,
      arrow,
      modal,
      lockScroll,
      closeOnDocumentClick,
      closeOnEscape,
      repositionOnResize,
      onOpen,
      onClose,
      contentStyle,
      overlayStyle,
      arrowStyle,
      className,
      keepTooltipInside,
      on
    },
    ref
  ) => {
    return (
      <div className='modal'>
        <Popup
          trigger={trigger}
          position={position}
          nested={nested}
          open={open}
          disabled={disabled}
          defaultOpen={defaultOpen}
          offsetX={offsetX}
          offsetY={offsetY}
          arrow={arrow}
          modal={modal}
          lockScroll={lockScroll}
          closeOnDocumentClick={closeOnDocumentClick}
          closeOnEscape={closeOnEscape}
          repositionOnResize={repositionOnResize}
          onOpen={onOpen}
          onClose={onClose}
          contentStyle={contentStyle}
          overlayStyle={overlayStyle}
          arrowStyle={arrowStyle}
          className={className}
          keepTooltipInside={keepTooltipInside}
          on={on}
          ref={ref}
        >
          <span>{children}</span>
        </Popup>
      </div>
    )
  }
)

const Header: FC<{}> = ({ children }) => {
  return <div className='header'>{children}</div>
}

const Footer: FC<{}> = ({ children }) => {
  return <div className='footer'>{children}</div>
}

export default PopupComponent
export { Header, Footer }
